import { type FC } from "react";
import { CircularProgress } from "@mui/material";
import { useGetAllGlobalMessages } from "../../hooks/useGetAllGlobalMessages";
import { useTypedSelector } from "../../redux/store";
import { useGetPrivateDialogues } from "../../hooks/useGetAllDialogues";
import { type DialogueResult } from "../../api/generated/data-contracts";
import { ChatListItem } from "./ChatListItem";
import { ActiveChatUsers } from "../Admin/components/ActiveChatUsers";

const GLOBAL_CHAT_KEY = "Global";
interface ChatsListItem {
  interlocutorId: string;
  lastMessageContent: string;
  createdTimestamp: number | undefined;
  interlocutorName: string | null | undefined;
}

export const ChatsList: FC = () => {
  const { isLoading: isGlobalMessagesLoading } = useGetAllGlobalMessages({
    offset: undefined,
    limit: undefined
  });

  const { isLoading: isDialoguesLoading } = useGetPrivateDialogues({
    offset: undefined,
    limit: undefined
  });

  const globalChatMsg = useTypedSelector((state) => state.globalChat);
  const privateDialogs = useTypedSelector(
    (state) => state.privateChat.dialogues
  );

  const isLoading = isGlobalMessagesLoading || isDialoguesLoading;
  const lastMessage = globalChatMsg.lastMessage;
  const senderName =
    lastMessage?.sender.userName ??
    lastMessage?.sender.fullName ??
    lastMessage?.sender.firstName ??
    "N/A";
  const lastGlobalMessageContent = lastMessage
    ? `${senderName}: ${lastMessage.content}`
    : "No messages yet";

  const chats: ChatsListItem[] = [
    {
      interlocutorId: GLOBAL_CHAT_KEY.toLowerCase(),
      lastMessageContent: lastGlobalMessageContent,
      createdTimestamp: lastMessage?.createdTimestamp,
      interlocutorName: GLOBAL_CHAT_KEY
    },
    ...privateDialogs.map((dialogue: DialogueResult) => ({
      interlocutorId: dialogue.interlocutorAuth0Id,
      lastMessageContent: dialogue.lastMessage.content,
      createdTimestamp: dialogue.lastMessage.createdTimestamp,
      interlocutorName:
        dialogue.interlocutor.fullName ?? dialogue.interlocutor.userName
    }))
  ];

  return (
    <>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <>
          <div
            style={{
              maxWidth: 600,
              width: "100%",
              color: "white",
              background: "#32393c",
              marginBottom: 20
            }}
          >
            {chats.map((chat) => {
              return (
                <ChatListItem
                  key={chat.interlocutorId}
                  interlocutorId={chat.interlocutorId}
                  lastMessageContent={chat.lastMessageContent}
                  createdTimestamp={chat.createdTimestamp}
                  isRead={true}
                  interlocutorName={chat.interlocutorName}
                />
              );
            })}
          </div>

          <ActiveChatUsers />
        </>
      )}
    </>
  );
};
